import { catchError, throwError } from 'rxjs';
import { OperatorFunction } from 'rxjs';

export function logError<T>(message?: string): OperatorFunction<T, T> {
    return (source$) =>
        source$.pipe(
            catchError((error) => {
                console.error(message ?? 'Unhandled error:', error);
                return throwError(() => error);
            }),
        );
}
